import KioskCheckout from "@/Pages/Auth/Kiosk/KioskCheckout";
import KioskDeliveryMethods from "@/Pages/Auth/Kiosk/KioskDeliveryMethods";
import KioskMenu from "@/Pages/Auth/Kiosk/KioskMenu";
import KioskPayments from "@/Pages/Auth/Kiosk/KioskPayments";
import KioskProductDetail from "@/Pages/Auth/Kiosk/KioskProductDetail";
import KioskStartScreen from "@/Pages/Auth/Kiosk/KioskStartScreen";
import useKioskSetup from "@/Pages/Auth/Kiosk/useKioskSetup";
import Overlay from "@/Components/Modal/Overlay";
import { Redirect, Switch } from "react-router-dom";
import AuthRoutes from "./Middleware/AuthRoutes";

const KioskRoutes = () => {
  useKioskSetup();

  return (
    <>
      {/* kiosk users don't get the app Layout, which normally renders the modal backdrop */}
      <Overlay />
      <Switch>
        <AuthRoutes exact path="/kiosk">
          <KioskStartScreen />
        </AuthRoutes>

        <AuthRoutes exact path="/kiosk/deliverymethods">
          <KioskDeliveryMethods />
        </AuthRoutes>

        <AuthRoutes exact path="/kiosk/menu/:id/checkout">
          <KioskCheckout />
        </AuthRoutes>

        <AuthRoutes exact path="/kiosk/menu/:id/payment">
          <KioskPayments />
        </AuthRoutes>

        <AuthRoutes exact path="/kiosk/menu/:id/:categoryId">
          <KioskMenu />
        </AuthRoutes>

        <AuthRoutes exact path="/kiosk/menu/:id/:categoryId/:productId">
          <KioskProductDetail />
        </AuthRoutes>

        <Redirect to="/kiosk" />
      </Switch>
    </>
  );
};

export default KioskRoutes;
